<ion-grid>
  <ion-row>
    <ion-col>
      <div *ngIf="announcement?.FEELING" style="margin-left: 4px">
        <div class="subheader">Feeling</div>
        <div style="margin-left: -5px">
          <span>
            {{ announcement?.FEELING | titlecase }}
          </span>
          <span style="font-size: 24px">{{ emoji }}</span>
        </div>
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <div *ngIf="announcement?.BODY">
        <div
          class="post-message-body"
          *ngIf="!showFullBody; else fullBody"
          [innerHtml]="
            announcement.BODY
              | truncateBody: 400:true
              | mentionified: announcement._MENTION_UIDS
              | safehtml
          "
        ></div>
        <ion-button
          style="float: right; margin-top: 5px"
          size="small"
          color="dark"
          fill="outline"
          *ngIf="announcement.BODY.length > 400 && !showFullBody"
          (click)="goToDetails()"
          >Read full post
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
        <ng-template #fullBody>
          <div
            (click)="clickBody($event)"
            class="post-message-body"
            [innerHtml]="
              announcement.BODY
                | mentionified: announcement._MENTION_UIDS
                | safehtml
            "
          ></div>
        </ng-template>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>

<div *ngIf="announcement?.IMAGE_PATHS.length > 0">
  <ion-grid style="padding: 0">
    <ion-row>
      <ion-col *ngFor="let path of announcement?.IMAGE_PATHS">
        <div class="post-image-wrapper">
          <app-post-image [path]="path"></app-post-image>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
